import BlankLayout from './layout/blankLayout.vue'
import SubmitReferralLayout from './submitReferral/route'
import ResumeRoute from './resume/route'
import ResumeApplySuccess from './resume/pc/resumeApplySuccess.vue'
import ResumeEditSuccess from './resume/pc/resumeEditSuccess.vue'
import homeRoute from './home/route'
import offerLetterRoute from './offerLetter/route'
import InterviewRoute from './interview/route'

const routes = [
  SubmitReferralLayout,
  ResumeRoute,
  ...homeRoute,
  offerLetterRoute,
  InterviewRoute
]

export default [
  {
    name: 'newPersonalRootLayout',
    path: '',
    component: BlankLayout,
    meta: {
      isRootLayout: true
    },
    children: routes
  },
  {
    name: 'personalApplySuccess',
    path: '/recruiting/personal/apply-success',
    component: ResumeApplySuccess,
    meta: {
      titleI18nKey: 'personal.resume.tabTitle.applySuccess',
      personalLayout: {
        blankPage: false
      },
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  },
  {
    name: 'personalEditResumeSuccess',
    path: '/recruiting/personal/edit-resume-success',
    component: ResumeEditSuccess,
    meta: {
      titleI18nKey: 'personal.resume.tabTitle.editSuccess',
      personalLayout: {
        blankPage: false
      },
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  }

]

export const allLayoutRoutes = routes
